<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-文章-列表
      -->
  <div>
    <div class="common-level-rail">
      <el-button style="float: right;"
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addArticle"
        >添加文章</el-button>

    </div>
    <el-form size="small" :inline="true" class="demo-form-inline">
      <el-form-item label="文章分类">
        <el-select size="small" v-model="category_id" placeholder="所有分类">
          <el-option label="全部" value="0"></el-option>
          <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select size="small" v-model="typea" placeholder="类型">
          <el-option label="全部" value=""></el-option>
          <el-option label="文章" value="1"></el-option>
          <el-option label="视频" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="审核状态">
        <el-select size="small" v-model="status" placeholder="状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="通过" value="1"></el-option>
          <el-option label="不通过" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="文章名称"><el-input size="small"  placeholder="请输入文章名称" v-model="article_name"></el-input></el-form-item>
      
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>

    <el-form size="small" :inline="true" class="demo-form-inline">
         <el-button
          size="small"
          type="primary"
          @click="ChangeState"
          >批量修改状态</el-button>
    </el-form>

    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection"  width="45"></el-table-column>
        <el-table-column
          prop="article_id"
          label="文章ID"
          width="60"
        ></el-table-column>
        <el-table-column prop="address" label="封面" width="50">
          <template slot-scope="scope">
            <img
              v-img-url="scope.row.image?scope.row.image.file_path:''"
              width="30"
              height="30"
            />
          </template>
        </el-table-column>
        <el-table-column prop="article_title" label="文章标题">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.article_title">
              {{ scope.row.article_title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="category.name"
          label="文章分类"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="virtual_views"
          label="实际阅读量"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="article_sort"
          label="文章排序"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="like"
          label="点赞"

          >
          <template slot-scope="scope">
            <span  style="color: #8ab1ff;" @click="like_click">{{ scope.row.like }}</span>
           
          </template>
      </el-table-column>
      <el-table-column
          prop="share"
          label="分享"

          >
          <template slot-scope="scope">
            <span  style="color: #8ab1ff;" @click="share_click">{{ scope.row.share }}</span>
           
          </template>
      </el-table-column>
      <el-table-column
          prop="collect"
          label="收藏"

          >
          <template slot-scope="scope">
            <span  style="color: #8ab1ff;" @click="collect_click">{{ scope.row.collect }}</span>
           
          </template>
      </el-table-column>
        <el-table-column prop="article_status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.article_status == 1" class="green">显示</span>
            <span v-if="scope.row.article_status == 0" class="gray">隐藏</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="添加时间"
          width="140"
        ></el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="editArticle(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="deleteArticle(scope.row)"
              type="text"
              size="small"
              >删除</el-button
            >

            <el-button v-if="scope.row.status == 0" @click="passClick(scope.row)" type="text" size="small">审核</el-button>
            <el-button v-if="scope.row.status == 0" @click="nopassClick(scope.row)" type="text" size="small">审核不通过</el-button>
          </template>
        </el-table-column>

    
      </el-table>

      <State v-if="open_state" :open_state="open_state" :select_list="select_list" @close="closeChangestate"></State>

      <Handle v-if="open_handle" :open_handle="open_handle" :code="code" :type="type"  @close="closeChangeHandle"></Handle>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleApi from "@/api/article.js";
import State from './dialog/State.vue';
import Handle from '@/components/handle/handle';
export default {
  components: {
    State,
    Handle
  },
  data() {
    return {
      /*分类*/
      categoryData: [],
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      multipleSelection:[],
      artcile_ids:[],
      /*全部分类*/
      categoryList: [],
      category_id:'',
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      article_name:'',
      open_state:false,
      select_list:[],

      open_handle:false,

      code:"",
      type:"article",
      typea:"",
      status:""
    };
  },
  created() {
    /*获取文章列表*/
    this.getTableList();
    this.getCateList();
  },
  methods: {
    like_click(){
      this.code = "like"
      this.open_handle = true;
    },
    share_click(){
      this.code = "share"
      this.open_handle = true;
    },
    collect_click(){
      this.code = "collect"
      this.open_handle = true;
    },
    closeChangeHandle(){
      this.open_handle = false;
    },
    /*获取文章列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.category_id = self.category_id
      Params.article_name = self.article_name
      Params.typea = self.typea;
      Params.status = self.status
      ArticleApi.articlelist(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.pageSize=data.data.list.per_page;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    handleSelectionChange(e) {
      this.multipleSelection = e;

    },

    /*打开批量修改状态*/
    ChangeState() {
      let article_ids=[];
      let params = this.multipleSelection;
      params.forEach((param)=>{
        article_ids.push(param.article_id);
      })
      article_ids=article_ids.join(',');
      // console.log(user_ids);
      if(article_ids==''){
        this.$message({
          message: '请选择修改状态的文章',
          type: 'error'
        });
      }else{
        this.open_state = true;
        this.select_list = article_ids;
      }

    },

     /*关闭批量修改状态*/
    closeChangestate(e){
      this.open_state=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    // 获取文章分类
    getCateList(){
      let self = this;
      ArticleApi.getCategory({}, true)
        .then((data) => {
          self.loading = false;
          self.categoryList = data.data.category
          // self.tableData = data.data.list.data;
          // self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*添加文章*/
    addArticle() {
      this.$router.push({
        path: "/plus/article/article/Add",
      });
    },

    /*编辑文章*/
    editArticle(row) {
      let params = row.article_id;
      this.$router.push({
        path: "/plus/article/article/Edit",
        query: {
          article_id: params,
        },
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*删除文章*/
    deleteArticle(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.loading = true;
          ArticleApi.deleteArticle(
            {
              article_id: row.article_id,
            },
            true
          )
            .then((data) => {
              self.$message({
                message: data.msg,
                type: "success",
              });
              self.loading = false;
              self.getTableList();
            })
            .catch((error) => {});
        })
        .catch(() => {});
    },

    /*删除文章分类*/
    deleteCategory(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          ArticleApi.deleteCategory(
            {
              category_id: row.category_id,
            },
            true
          )
            .then((data) => {
              self.$message({
                message: data.msg,
                type: "success",
              });
              self.getTableList();
            })
            .catch((error) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleClick(tab, event) {},

    /*打开分类添加*/
    addCategory() {
      this.open_add = true;
    },

    // 批量修改状态
    editStatus(){

    },
    /*打开分类编辑*/
    editCategory(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    },
    passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        article_id:item.article_id,
        status:1
      }
      ArticleApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');

      var Params = {
        article_id:item.article_id,
        status:2,
        reject_val:reject_val
      }
      ArticleApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/article/Index.vue